<template>
    <div class="list-generator-preview">
        <div class="list-action-panel">
            <b-btn variant="default"
                   v-b-toggle="'list-actions'">
                <open-icon name="chevron-bottom" v-if="listActionsVisible"></open-icon>
                <open-icon name="chevron-right" v-if="!listActionsVisible"></open-icon>
                List Actions
            </b-btn>

            <b-collapse id="list-actions"
                        v-model="listActionsVisible">
                <b-card no-body title="List Actions">
                    <b-card-body>
                        <b-row>
                            <b-col cols="9">
                                Click the "Random" button to create a randomized list (click again to re-randomize) or click the "Original" button to revert to the original order.
                            </b-col>
                            <b-col cols="3" class="text-right">
                                <b-btn variant="primary" class="mb-1" @click="createOriginalList()">
                                    Original
                                </b-btn>
                                <b-btn variant="primary" class="ml-3" @click="createRandomList()">
                                    Random
                                </b-btn>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
            </b-collapse>
        </div>

        <!-- NB: using v-for with range -->
        <tool-output-page v-for="index in itemCollections.length"
                          :page-number="index"
                          :page-count="itemCollections.length"
                          v-if="listExists">
            <div class="list-generator-preview-header" v-if="index == 1">
                <h3 class="text-center">{{ docData.listTitle }}</h3>
                <p class="text-center" v-if="docData.listDescription">{{docData.listDescription}}</p>
            </div>

            <b-alert show v-if="!docData.sampleSize" variant="info">
                Set a sample size in Step 3 of the Compose tab above before creating your list
            </b-alert>
            <table class="list-table" v-if="docData.randomizedListItems">
                <tr v-for="index in docData.sampleSize">
                    <td class="item">
                        {{docData.randomizedListItems[index-1]}}
                    </td>
                </tr>
            </table>
        </tool-output-page>
        <b-alert show v-else variant="info">
            Add list items in Step 2 of the Compose tab above to begin building a list
        </b-alert>

    </div>

</template>

<script>

import Vue from 'vue'
import ToolMixin from '@/providers/ToolMixin'
import ListGeneratorMixin from '@/providers/ListGeneratorMixin'

export default Vue.extend({
    name: "ListGeneratorPreview",
    mixins: [ToolMixin, ListGeneratorMixin],
    data() {
        return {
            listActionsVisible: true
        }
    },
    computed: {
        linesPerPage() {
            if (this.landscape) {
                return 12
            }
            if (this.docData.fontSize === "small") {
                return 37
            } else {
                return 30
            }
        },
        listExists() {
            return this.docData.listText !== undefined && this.docData.listText.length > 0
        },
        itemCollections() {
            let itemCollections = []
            itemCollections.push(this.docData.randomizedListItems)
            return itemCollections
        }
    },
    methods: {
        createRandomList() {
            let originalList = this.docData.listText.split(/\r?\n/)
            let randomList = []
            while (originalList.length > 0) {
                const index = Math.floor(Math.random() * originalList.length)
                randomList.push(originalList[index])
                originalList.splice(index, 1)
            }
            Vue.set(this.docData, 'randomizedListItems', randomList)
            console.log(this.docData.randomizedListItems)
        },
        createOriginalList() {
            Vue.set(this.docData, 'randomizedListItems', this.docData.listText.split(/\r?\n/))
            console.log(this.docData.randomizedListItems)
        }
    },
})

</script>

<style lang="scss">

.list-action-panel {
    @media print {
        display: none;
    }
}

</style>
